registerGlobal('CookieUtils');

CookieUtils.setCookie = function(c_name, value, expireminutes) {
    var exdate = new Date();
    exdate.setMinutes(exdate.getMinutes() + expireminutes);
    document.cookie = c_name + "=" + escape(value) +
        ((expireminutes == null) ? "" : ";expires=" + exdate.toUTCString());
}

CookieUtils.getCookie = function(c_name) {
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

CookieUtils.getUserID = function() {
  var guid = function() {
    var s4 = function() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  var key = "EmscriptenApp.UserID";
  var value = CookieUtils.getCookie(key);
  if (value != "") return value;
  value = guid();
  CookieUtils.setCookie(key, value, 2147483647);
  return value;
}



//////////////////
// WEBPACK FOOTER
// /src/claw/sdk/src/claw/system/emscripten/Application.cookieutils.js
// module id = 11
// module chunks = 0